module.exports = {
    bazaar_link: 'https://redirect.appmetrica.yandex.com/serve/243413381082522868?campaign=CafeBazaar',
    play_link: 'https://redirect.appmetrica.yandex.com/serve/1036046929106097450?campaign=GooglePlay',
    store_link: '/ios-tutorial',
    web_app_link: 'https://app.snapp.taxi/pre-ride?utm_source=website&utm_medium=webapp-button',
    sibapp_link: 'https://sibapp.com/applications/snapp',
    sibche_link: 'https://sibche.com/applications/snapp-3',
    sms_link: 'https://goo.gl/smvXMN',
    iApp_link: 'https://app.iapps.ir/i/191622396'
};



// WEBPACK FOOTER //
// ./src/js/config/DownloadLinks.js